import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getBillTos } from "@insite/client-framework/Services/CustomersService";

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setFieldValue from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SetFieldValue";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getBillTosDataView, getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { ContactFormContext } from "@insite/content-library/Widgets/ContactUs/ContactForm";
import TextField from "@insite/mobius/TextField";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    currentLocation: getLocation(state),
    customerNumber: state.components.contactUsForm.fieldValues["customerNumber"],
    currentUrl: state.components.contactUsForm.fieldValues["currentUrl"],
    getERPData: getSession(state),
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const HiddenFIelds: React.FC<Props> = ({ setFieldValue, currentLocation, getERPData }) => {
    React.useEffect(() => {
        setFieldValue({ key: "customerNumber", value: getERPData.properties.billToErpNumber || "" });
        setFieldValue({ key: "currentUrl", value: currentLocation.pathname || "" });
    }, [currentLocation, getERPData]);

    return (
        <>
            <StyledWrapper hidden></StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(HiddenFIelds),
    definition: {
        group: "Contact Us",
        icon: "input-pipe",
    },
};

export default widgetModule;
